import { GuardedDeletionService } from 'orchestrator';
import { Component, inject } from '@angular/core';
import { CertificateTypeService } from '../proxy/planning/controllers';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  CertificateTypeCreateDto,
  CertificateTypeDto,
  CertificateTypeExcelDownloadDto,
  CertificateTypeUpdateDto,
} from '../proxy/planning/dtos/certificate-type';
import { CERTIFICATETYPE_CONFIG, CERTIFICATETYPE_FIELDS } from './certificate-type.config';
import { BaseCrudComponent, CrudPage, GenericForm } from '@zendra/shared';

@Component({
  selector: 'app-certificate-type',
  imports: [
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, CertificateTypeService, ConfirmationService],
  templateUrl: './certificate-type.html',
  styleUrl: './certificate-type.scss',
})
export class CertificateType extends BaseCrudComponent<
  CertificateTypeDto,
  CertificateTypeCreateDto,
  CertificateTypeUpdateDto,
  CertificateTypeExcelDownloadDto
> {
  private readonly guardedDeletion = inject(GuardedDeletionService);
  service = {
    ...inject(CertificateTypeService),
    deleteByIds: (ids: number[]) => this.guardedDeletion.deleteByIds('CertificateType', ids),
  };
  config = CERTIFICATETYPE_CONFIG;
  fields = CERTIFICATETYPE_FIELDS;

  protected prepareUpdateDto(data: any, selected: CertificateTypeDto): CertificateTypeUpdateDto {
    return {
      name: data.name,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'CertificateType';
  }
}
